import { render, staticRenderFns } from "./Hosting.vue?vue&type=template&id=572672cb&scoped=true"
import script from "./Hosting.vue?vue&type=script&lang=js"
export * from "./Hosting.vue?vue&type=script&lang=js"
import style0 from "./Hosting.vue?vue&type=style&index=0&id=572672cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572672cb",
  null
  
)

export default component.exports